import gsap from "gsap/all";
import fadeElements from "./fadeElements";

export default function frontpage() {

    const logo                  = document.querySelector('.js-preloader-logo');
    const logoDefault           = document.querySelector('.js-preloader-logo-default');

    if(!logo){
        return false;
    }

    const fade                  = fadeElements();
    const title                 = document.querySelector('.js-preloader-title');
    const text                  = document.querySelector('.js-preloader-text');
    const btn                   = document.querySelector('.js-preloader-btn');
    const cityButtons = btn.querySelectorAll('a');

    const video                 = document.querySelector('.js-preloader-video');
    const letters               = logo.querySelectorAll('svg');
    const letterMoveDelay       = 6.5;
    const letterMoveDuration    = 1.3;


    // Reset and kill all animations
    const resetAnimations = () => {
        // Kill all tweens for elements we're going to animate
        gsap.killTweensOf(letters);
        gsap.killTweensOf(title);
        gsap.killTweensOf(text);
        gsap.killTweensOf(btn.querySelectorAll('a'));

        // Make sure buttons are visible
        gsap.set(btn.querySelectorAll('a'), {opacity: 1, y: 0});
    };

    const allDefaults = () => {
        const mainLogo              = document.querySelector('.js-main-logo');
        const lettersDefault        = logoDefault.querySelectorAll('svg');

        fade.fadeDefaultTop({target: title});
        fade.fadeDefaultTop({target: text});
        fade.fadeDefaultTop({target: btn.querySelectorAll('a')[0]});
        fade.fadeDefaultTop({target: btn.querySelectorAll('a')[1]});
        fade.fadeDefaultTop({target: btn.querySelectorAll('a')[2]});
        fade.fadeDefaultTop({target: btn.querySelectorAll('a')[3]});
        fade.fadeDefaultTop({target: btn.querySelectorAll('a')[4]});

        gsap.set(logoDefault, {width: '100%', left: 0});
        gsap.set(mainLogo, { opacity: 0 });
    
        for (let index = 0; index < letters.length; index++) {
            const letter = letters[index];
            const getReact = lettersDefault[index].getBoundingClientRect();
            gsap.set(letter, {
                width: getReact.width,
                left: getReact.left,
                bottom: '-'+window.innerHeight
            });
        }
    } 

    const letterUp = (letter, delay) => {
        return gsap.to(letter, {
            bottom: 50,
            delay: (delay/letterMoveDelay),
            duration: letterMoveDuration,
            ease: 'power4.out'
        });
    }

    const showAllElements = () => {

        fade.fadeInTop({
            target: title,
            delay: 0.9
        });

        fade.fadeInTop({
            target: text,
            delay: 1.1
        });



        let delay = 1.3;
        cityButtons.forEach((button, index)=> {
            fade.fadeInTop({
                target: btn.querySelectorAll('a')[index],
                delay: delay
            });
            delay += 0.2
        })

    }

    const letterToTop = (letter, index) => {
        const lettersDefault    = logoDefault.querySelectorAll('svg');
        const getReact          = lettersDefault[index].getBoundingClientRect();
        const mainLogo          = document.querySelector('.js-main-logo');

        return gsap.to(letter, {
            width: getReact.width,
            left: getReact.left,
            bottom: (window.innerHeight)-(mainLogo.clientHeight)+5,
            delay: (index/letterMoveDelay),
            duration: letterMoveDuration,
            ease: 'power3.out',
            onComplete: showAllElements()
        });
    }

    const loadPreloader = () => {
        const mainLogo              = document.querySelector('.js-main-logo');
        const mainLogoReact         = mainLogo.getBoundingClientRect();

        for (let index = 0; index < letters.length; index++) {

            gsap.set(logoDefault, {width: mainLogoReact.width, left: mainLogoReact.left});
            
            const letter = letters[index];
            let loaderCount = 0;
            letterUp(letter, index);

            let loader = setInterval(() => {
    
                if(video.readyState >= 3 && mainLogo.querySelector('img').complete && loaderCount > 12){

                    letterToTop(letter, index);
                    clearInterval(loader);

                }

                loaderCount++; 
        
            },100);
        }
    }

    /// cities click
    const leaveFrontpage = (link) => {
        fade.fadeOutBottom({
            target: title,
        });

        fade.fadeOutBottom({
            target: text,
            delay: 0.1
        });


        let delay = 0;
        cityButtons.forEach((button, index)=> {
            fade.fadeInTop({
                target: btn.querySelectorAll('a')[index],
                delay: delay
            });
            delay += 0.2
        })
        //
        // fade.fadeOutBottom({
        //     target: btn.querySelectorAll('a')[0],
        //     delay: 0
        // });
        //
        // fade.fadeOutBottom({
        //     target: btn.querySelectorAll('a')[1],
        //     delay: 0.2
        // });
        //
        // fade.fadeOutBottom({
        //     target: btn.querySelectorAll('a')[2],
        //     delay: 0.4
        // });
        //
        // fade.fadeOutBottom({
        //     target: btn.querySelectorAll('a')[3],
        //     delay: 0.6
        // });
        //
        // fade.fadeOutBottom({
        //     target: btn.querySelectorAll('a')[4],
        //     delay: 0.8
        // });
        
        setTimeout(() => {
            window.location.href = link;
        }, 600);
    } 

    const initAnimations = () => {
        resetAnimations();
        allDefaults();
        loadPreloader();
    }
    initAnimations();

    window.addEventListener('resize', initAnimations);


    // Listen for back/forward navigation
    window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
            initAnimations();
        }
    });

    for(const link of btn.querySelectorAll('a')){
        link.addEventListener('click', (e) => {
            e.preventDefault();
            leaveFrontpage(link.href);
        });
    }

}